export default {"src":"/_next/static/media/arrow.73b11733.svg","height":54,"width":30};